import $ from "jquery";

import {paymentOnSubmitTrack} from "./paymentSubmitCommon";
import {inputHasError, validateCVV, validateDisabledButton} from "./validation";

let cardInput;
let cardExpiryDate;
let cvvInput;
let paymentSubmit;
let paymentDetails;
// let membershipCheckbox;
// let termsCheckbox;
let alreadySubmitted;
let paymentForm;

// let cardValue = "";
let cvvValue = "";

let inputsToCheck = [];

const onChangeCVV = (event) => {
  const value = event.target.value;
  if (!validateCVV(value)) {
    event.preventDefault();
    event.target.value = cvvValue;
    return false
  }
  cvvValue = value;
}

const onChangeCard = (event) => {
  const value = event.target.value;
  if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
    return;
  }
  event.target.value = value.replace(/\W/gi, '').replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();
}

function onChangeExpiry(event) {
  const currentValue = event.target.value;
  let inputValue = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters

  if (inputValue.length > 2 || (inputValue.length === 2 && (currentValue.length === 3) && currentValue[2] === "/")) {
    // Insert a slash after the second digit if it's not already there
    inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
  }

  // Update the input value
  event.target.value = inputValue;
}

const onInputFocus = (event) => {
  if (!event.target.classList.contains("ui-input--touched")) {
    event.target.classList.add("ui-input--touched")
  }
  if (!event.target.classList.contains("ui-input--focused")) {
    event.target.classList.add("ui-input--focused")
  }
}

export const onChangeInput = (event, isBlur = false) => {
  const hasError = inputHasError(event.target, true);

  let neededInputs = inputsToCheck;

  if (neededInputs
    .filter(input => input && (input.name !== event.target.name))
    .every(input => input.value)) {
    if (hasError && event.target.classList.contains("ui-input--focused")) {
      event.target.classList.remove("ui-input--error");
    }
    validateDisabledButton(paymentSubmit, neededInputs);
  }
  hasError
    ? event.target.classList.add("ui-input--error")
    : event.target.classList.remove("ui-input--error");
  if (event.target.value && !event.target.classList.contains("ui-input--has-value")) {
    event.target.classList.add("ui-input--has-value")
  } else if (!event.target.value && event.target.classList.contains("ui-input--has-value")) {
    event.target.classList.remove("ui-input--has-value")
  }
  if (isBlur) {
    event.target.classList.remove("ui-input--focused");
  }
}

const onBlurInput = (event) => {
  onChangeInput(event, true);
}

const onPaymentSubmit = (event) => {
  inputsToCheck.forEach(input => {
    if (!input) {
      return
    }
    onBlurInput({target: input})
  });
  const buttonDisabled = validateDisabledButton(paymentSubmit, inputsToCheck);
  if (buttonDisabled || alreadySubmitted) {
    paymentSubmit.disabled = true;
    event.preventDefault();
    if (paymentDetails) {
      $("html, body").animate({scrollTop: paymentDetails.offsetTop + 150}, 500)
    }
    return false
  }
  alreadySubmitted = true;
  paymentOnSubmitTrack(event);
}

export const paymentLogic = () => {

  paymentForm = document.querySelector(".payment-form");
  if (!paymentForm) {
    return
  }

  cvvInput = document.getElementById("card_cvv");
  cardInput = document.getElementById("card_number");
  cardExpiryDate = document.getElementById("card_expiry");
  paymentSubmit = document.getElementById("payment_submit");
  paymentDetails = document.getElementById("payment_details");
  // membershipCheckbox = document.getElementById("payment_membership");
  // termsCheckbox = document.getElementById("payment_terms");

  if (window.safari) {
    const paymentDiv = document.querySelector(".payment");
    if (paymentDiv) {
      paymentDiv.classList.add("payment--safari")
    }
  }

  if (cardInput) {
    cardInput.addEventListener("input", onChangeCard);
    cardInput.addEventListener("focus", onInputFocus);
  }
  if (cardExpiryDate) {
    cardExpiryDate.addEventListener("input", onChangeExpiry);
    cardExpiryDate.addEventListener("focus", onInputFocus);
  }
  if (cvvInput) {
    cvvInput.addEventListener("input", onChangeCVV);
    cvvInput.addEventListener("focus", onInputFocus);
  }
  if (paymentSubmit) {
    paymentSubmit.addEventListener("click", onPaymentSubmit);
  }
  inputsToCheck = [].slice.call(paymentForm.querySelectorAll("input[required]"));
  inputsToCheck.forEach(inputElement => {
    if (inputElement) {
      inputElement.addEventListener("focus", onInputFocus);
      inputElement.addEventListener("input", onChangeInput);
      inputElement.addEventListener("blur", onBlurInput);
      if (inputElement.value) {
        inputElement.classList.add("ui-input--touched")
      }
    }
  })
  console.log("inputsToCheck", inputsToCheck);
}